import React from "react";

//module imports
import AppHeader from "../appHeader";
import MyClasses from "./MyClasses";

function MyClassesMain() {
  return (
    <div>
      <AppHeader />
      <MyClasses />
    </div>
  );
}

export default MyClassesMain;
